import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TAG = "listTag";
export const GET_DETAIL_TAG = "detailTag";
export const SAVE_TAG = "saveTag";
export const UPDATE_TAG = "updateTag";
export const DELETE_TAG = "deleteTag";
export const UPLOAD_TAG_IMAGE = "/upload/tags";


export const SET_LIST_TAG = "setListTag";
export const SET_DETAIL_TAG = "setDetailTag";


export const SET_LIST_TAG_SEARCH = "setListTagSearch";
export const GET_LIST_TAG_SEARCH = "getListTagSearch";


const state = {
    tags: [],
    tag: {},
    tagSearch : [],

};

const getters = {
    tags(state) {
        return state.tags;
    },
    tagDetail(state) {
        return state.tag;
    },
    tagSearch(state) {
        return state.tagSearch;
    },
};

const actions = {
    [GET_LIST_TAG](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_TAG).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TAG, data);
                    context.commit(SET_LIST_TAG_SEARCH, data.data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_TAG_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_TAG_SEARCH, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TAG_SEARCH, data.data.tags);
                }
                resolve(data);
            });
        });
    },
    
    [GET_DETAIL_TAG](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TAG}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TAG, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_TAG_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(API.UPLOAD_TAG_IMAGE, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [SAVE_TAG](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TAG}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_TAG](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_TAG}`,payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_TAG](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TAG}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_TAG](state, data) {
        state.tags = data.data;
    },
    [SET_DETAIL_TAG](state, data) {
        state.tag = data.data;
    }
    ,
    [SET_LIST_TAG_SEARCH](state, data) {
        state.tagSearch = data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
